import { LayoutPadding } from "./LayoutPadding";
import logoImg from '../../assets/logo.webp';

interface NavbarProps {
  logo: JSX.Element;
  links: JSX.Element[];
}

export function NavBar({ logo, links }: NavbarProps): JSX.Element {
  return (
    <nav className="w-full bg-transparent absolute top-0 left-0 z-10">
      <LayoutPadding>
        <div className="flex py-9 flex-wrap items-center justify-center mx-auto">
          <NavbarLogo>{logo}</NavbarLogo>
          <NavbarLinks>{links}</NavbarLinks>
        </div>
      </LayoutPadding>
    </nav>
  );
}

interface NavbarLinksProps {
  children: JSX.Element[];
}

export function NavbarLinks({ children }: NavbarLinksProps): JSX.Element {
  return (
    <div className="flex content-center w-full h-full capitalize sm:w-1/2 sm:justify-end text-gray-700 tracking-wider">
      <ul className="flex items-center justify-center h-full flex-1 list-reset sm:flex-none space-x-10">
        {children.map((child, index) => (
          <li key={index}>{child}</li>
        ))}
      </ul>
    </div>
  );
}

interface NavbarLogoProps {
  children: JSX.Element;
}

export function NavbarLogo({ children }: NavbarLogoProps): JSX.Element {
  return (
    <>
      {/* Mobile logo */}
      <div className="flex lg:hidden justify-center w-full">
        <img src={logoImg} alt="Logo" className="h-16 w-auto" />
      </div>
      
      {/* Desktop logo */}
      <div className="hidden lg:flex justify-center w-full text-gray-50 sm:w-1/2 sm:justify-start">
        <a
          className="no-underline text-gray-50 hover:text-gray-50 hover:no-underline"
          href="/"
          target="_blank"
          rel="noreferrer"
        >
          <span className="pl-4 text-2xl capitalize hover:animate-pulse">
            {children}
          </span>
        </a>
      </div>
    </>
  );
}
